<div id="chart" *ngIf="sovChartValues?.chartData && chartOptions?.series">
  <label style="font-size: medium">
    <strong *ngIf="coverageTitle">{{ coverageTitle }}</strong>
    <!-- TODO This is not showing the correct label in some cases
    <span *ngIf="sovChartValues?.query?.value" class="info-icon-wrapper">
      <i
        class="pi pi-info-circle"
        style="
          cursor: pointer;
          margin-left: 5px;
          font-size: 0.85em;
          vertical-align: super;
          color: #4a90e2;
        "
      ></i>
      <span class="custom-tooltip">{{ sovChartValues.query.value }}</span>
    </span>
    -->
  </label>
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [labels]="chartOptions.labels"
    [legend]="chartOptions.legend"
    [title]="chartOptions.title"
    [colors]="chartOptions.colors"
    [theme]="chartOptions.theme"
    [responsive]="chartOptions.responsive"
    [tooltip]="chartOptions.tooltip"
    [dataLabels]="chartOptions.dataLabels"
  ></apx-chart>
  <div>
    {{ percentageLabel }}
    <b>{{ truncatedChartLabel }}</b>
  </div>
  <div class="p-text-italic">
    <small>
      {{ sovChartValues.chartData[1] | number }} out of
      {{ sovChartValues.chartDataTotal | number }} articles in the past year
    </small>
  </div>
</div>
